import Illustration from "../../../assets/images/support-illustration.svg";
import Navbar from "../../parts/Navbar/Navbar";

import "./SupportScreen.scss";

export default function SupportScreen() {
  return (
    <div>
      <Navbar pageTitle="Support" />

      <div className="Container">
        <div className="Container-content">
          <div className="Card SupportScreen">
            <h1 className="SupportScreen-title">
              Avez-vous un problème? Contactez notre <br /> équipe de support
            </h1>

            <div style={{ marginTop: "38px", textAlign: "center" }}>
              <a
                href="https://cds.asin.bj/"
                target="_blank"
                rel="noreferrer"
                className="Btn primary"
              >
                Nous contacter
              </a>
            </div>

            <img src={Illustration} alt="" className="SupportScreen-img" />
          </div>
        </div>
      </div>
    </div>
  );
}
